import React, { useState, useEffect, useRef } from "react";
import "./ViewBorrower.css";
// import { AiOutlineTable } from "react-icons/ai";
import Sidebar from "../../../Sidebar/Sidebar";
import MenuItem from "@mui/material/MenuItem";
import { Autocomplete, TextField, Button, Select } from "@mui/material";
import { ImBin } from "react-icons/im";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { BsPencilSquare } from "react-icons/bs";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../../App";
import Cookies from 'js-cookie';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Tooltip from '@mui/material/Tooltip';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaFileExcel } from "react-icons/fa";
import RefreshIcon from '@mui/icons-material/Refresh';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '20px'
};

const FilterModal = ({ open, handleClose, handleFilter, sourceName, setSourceName, branchName, setBranchName }) => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [usersArr, setUsersArr] = useState([]);
  const [branchArr, setBranchArr] = useState([]);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');

  const handleSubmit = (e) => {
    const filters = {};
    if (sourceName) filters.borrower_sourcecode = sourceName;
    if (branchName) filters.borrower_branchname = branchName;
    if (fromDate) filters.from_date = fromDate;
    if (toDate) filters.to_date = toDate;
    handleFilter(filters);
    handleClose();
  };

  const handleReset = () => {
    setSourceName('');
    setBranchName('');
    setFromDate('');
    setToDate('');
    const filters = {};
    handleFilter(filters);
    handleClose();
  };

  const sourceCodeSuggestions = async (inputValue) => {
    if (!inputValue) return;
    // console.log(inputValue);
    try {
      const data = await axios.get(`${url}/borrower/filter/${inputValue}`,
        { headers: { token: token, email: email } }
      );
      // console.log(data.data);
      if (!data.data.auth) {
        toast.error(data?.data?.message);
        return;
      }

      if (data.data.auth) {
        setUsersArr(data?.data?.message);
        return;
      }
    } catch (error) {
      return;
    }
  }

  const fetchBranchNames = async () => {
    try {
      const branches = await axios.get(`${url}/borrower/active/branches`, {
        headers: { token, email }
      });

      console.log(branches);
      if (branches?.data?.auth) {
        console.log(branches?.data);
        const allBranches = branches?.data?.message;

        if (email === 'rupesh.bishnoi@credin.in') {
          setBranchArr(branches?.data?.message.map((item) => item?.branch_name));
          return;
        }

        const checkMappedData = await axios.post(`${url}/user/getsingle`, {
          token, email
        });
        let mappedData = checkMappedData?.data[0]?.mapped_data;
        console.log(mappedData);

        if (mappedData.length === 1) {
          if (mappedData[0]?.toLowerCase().startsWith('br')) {
            // setBranchArr(mappedData)
            const branchNames = allBranches
              .filter((branch) => mappedData.includes(branch?.branch_id))
              .map((branch) => branch?.branch_name);
            setBranchArr(branchNames);
            console.log(branchNames);
          } else if (mappedData[0]?.toLowerCase().startsWith('co')) {
            setBranchArr(branches?.data?.message?.map((item) => item?.branch_name));
          } else if (mappedData[0]?.toLowerCase()?.startsWith('nb')) {
            setBranchArr(branches?.data?.message?.map((item) => item?.branch_name));
          }
        } else {
          const branchNames = allBranches
            .filter((branch) => mappedData.includes(branch.branch_id))
            .map((branch) => branch.branch_name);
          console.log(branchNames);
          setBranchArr(branchNames);
          // setBranchArr(checkMappedData.data[0]?.mapped_data);
        }
        // setBranchArr(branches.data.message.map((item) => item.branch_name));
      } else {
        toast.error(branches.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (open) {
      fetchBranchNames();
    }
    //eslint-disable-next-line
  }, [open]);

  return (
    <Modal slotProps={{
      backdrop: {
        sx: {
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(0,0,0,0.3)',
        },
      },
    }} open={open} onClose={handleClose}>
      <Box sx={style}>
        <h2 id="modal-title">Filter</h2>

        <Autocomplete
          freeSolo
          options={usersArr}
          inputValue={sourceName}
          onInputChange={(event, newValue) => {
            setSourceName(newValue);
            sourceCodeSuggestions(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Source Code"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Select
          label="Branch Name"
          value={branchName}
          onChange={(e) => setBranchName(e.target.value)}
          fullWidth
          displayEmpty
          margin="normal"
        >
          <MenuItem value="" disabled>
            Select Branch
          </MenuItem>
          {branchArr.map((branch, index) => (
            <MenuItem key={index} value={branch}>
              {branch}
            </MenuItem>
          ))}
        </Select>

        <TextField
          label="From Date"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date().toISOString().split("T")[0],
          }}
        />
        <TextField
          label="To Date"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date().toISOString().split("T")[0],
          }}
        />
        <Button variant="contained" onClick={handleSubmit} style={{ marginTop: '20px' }}>Apply Filter</Button>
        <Button variant="outlined" onClick={handleReset} style={{ marginTop: '20px', marginLeft: '10px' }}>Reset Filter</Button>
      </Box>
    </Modal>
  );
};

export default function ViewBorrower() {
  const [open, setOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setFilters] = useState({});
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [sourceName, setSourceName] = useState('');
  const [branchName, setBranchName] = useState('');
  // eslint-disable-next-line
  const [editStatusIndex, setEditStatusIndex] = useState(null);
  // eslint-disable-next-line
  const [statusEditVisible, setStatusEditVisible] = useState(false);
  // eslint-disable-next-line
  const [statusIncRej, setStatusIncRej] = useState(false);
  // eslint-disable-next-line
  const [statusIncDrop, setStatusIncDrop] = useState(false);
  // eslint-disable-next-line
  const [statusIncSoft, setStatusIncSoft] = useState(false);
  const navigate = useNavigate();
  const [borrowers, setBorrowers] = useState([]);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [rowNumber, setRowNumber] = useState(10);
  var [pageCount, setPageCount] = useState(1);
  const [isOpen, setIsOpen] = useState(true);
  const [borrowerStatus, setborrowerStatus] = useState(null);
  const [visible, setvisible] = useState(false);
  const [EditBorrowerVisible, setEditBorrowerVisible] = useState(false);
  const [DeleteBorrowerVisible, setDeleteBorrowerVisible] = useState(false);
  const [BorrowerDetailsVisible, setBorrowerDetailsVisible] = useState(false);
  const [isSearchCompeleted, setisSearchCompeleted] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const openView = (val) => setIsOpen(val);
  const rowRefs = useRef([]);
  const SearchBoxRef = useRef(null);
  const [ip, setIp] = useState('');


  const fetch = async () => {
    try {
      const { data } = await axios.get("https://api.ipify.org");
      setIp(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // document.title ="LMS View Borrowers ";
    fetch()
  }, [])
  useEffect(() => {

    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          setEditBorrowerVisible(res.data[0].permission.edit_borrower);
          setDeleteBorrowerVisible(res.data[0].permission.delete_borrower);
          setStatusEditVisible(res.data[0].permission.statusEditVisible)
          setStatusIncRej(res.data[0].permission.statusIncRej)
          setStatusIncDrop(res.data[0].permission.statusIncDrop)
          setStatusIncSoft(res.data[0].permission.statusIncSoft)
          setBorrowerDetailsVisible(res.data[0].permission.borrower_details)
        })
        .catch((err) => {
          // console.log(err);
        })
    };

    if (borrowerStatus) {
      console.log(borrowerStatus);
      setOpen(true);
      axios
        .post(url + "/borrower/completefilter", {
          token: token,
          email: email,
          filter_field: borrowerStatus,
          pageSize: rowNumber,
          page: pageCount,
        })

        .then((res) => {
          console.log(res);
          if (res.data.auth === false) {
            setOpen(false);
            // toast.error(res.data.message);
          } else {
            setOpen(false);
            if (res.data.message.length === 0 && pageCount > 1)
              return setPageCount((pageCount) => pageCount - 1);
            setBorrowers(res.data.message);
          }
        })

        .catch((err) => {
          setOpen(false);
        })
    } else
      if (Object.keys(filters).length > 0) {

        const fetchData = async () => {
          try {
            setOpen(true);
            const response = await axios.post(url + "/borrower/filterborrower", {
              token: token,
              email: email,
              ...filters,
              pageSize: rowNumber,
              page: pageCount,
            });
            console.log(response.data);
            setOpen(false);
            if (response.data.message.length === 0 && pageCount > 1) return setPageCount((pageCount) => pageCount - 1);
            setBorrowers(response.data.message);
          } catch (error) {
            console.error('Error fetching data:', error);
            setOpen(false);
          }
        };

        fetchData();

      } else {
        setOpen(true);
        axios
          .post(url + "/borrower/getall", {
            token: token,
            email: email,
            pageSize: rowNumber,
            page: pageCount,
          })
          .then((res) => {
            console.log(res);
            if (res.data.logout === true) {
              setOpen(false);
              setTimeout(() => {
                toast.error(res.data.message);
                navigate("/");
              }, 3000);
            }
            else if (res.data.auth === false) {
              setOpen(false);
              // toast.error(res.data.message);
            } else {
              setOpen(false);
              if (res.data.message.length === 0 && pageCount > 1)
                return setPageCount((pageCount) => pageCount - 1);
              setBorrowers(res.data.message);
            }
          })
          .catch((err) => {
            setOpen(false);
            // console.log(err);
          });
      }

    //eslint-disable-next-line
  }, [rowNumber, pageCount]);

  const [query, setQuery] = useState("");

  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  const abc = (borrowerBirthday) => {
    let newDate = new Date(borrowerBirthday);
    return `${newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate()
      }-${newDate.getMonth() + 1 < 10
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1
      }-${newDate.getFullYear()}`;
  };

  const handleDeleteBorrower = (borrower_uniqueno) => {
    let text = "Are you sure you want to delete " + borrower_uniqueno + "?";
    if (window.confirm(text) === true) {
      axios
        .post(url + "/borrower/delete", {
          token: token,
          email: email,
          hostname: window.location.hostname,
          ip: ip,
          borrower_uniqueno: borrower_uniqueno,
        })
        .then((res) => {
          // // console.log(res);
          if (res.data.auth === true) {
            toast.success(res.data.message);
            setTimeout(() => {
              refresh();
            }, 3000);
            axios
              .post(url + "/borrower/getall", {
                token: token,
                email: email,
              })
              .then((res) => {
                console.log(res.data);
                if (res.data.auth === false) {
                  toast.error(res.data.message);
                  navigate("/");
                } else {
                  setBorrowers(res?.data?.message);
                  // console.log(res.data);
                }
              })
              .catch((err) => {
                // console.log(err);
                toast.error(err);
              });
          } else {
            toast.error(res.data.message);
            // console.log(res);
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const getPageLoad = (e) => {
    // setOpen(true);
    if (e === "inc") {
      setPageCount((pageCount) => pageCount + 1);
    } else {
      setPageCount((pageCount) => pageCount - 1);
    }
  };

  const serachDateApi = () => {
    setOpen(true);
    setisSearchCompeleted(false);
    if (query.trimStart().trimEnd().length === 0) {
      setOpen(false);
      toast.error("Please enter a keyword to search.");
      return;
    }
    axios
      .post(url + "/borrower/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query.trimStart().trimEnd(),
      })
      .then((res) => {
        // console.log(res)
        if (res.data.auth === false) {
          setOpen(false);
          setTimeout(() => {
            refresh();;
          }, 3000);
          toast.error(res.data.message);
        } else {
          setOpen(false);
          if (res.data.message.length === 0) return setBorrowers([]);
          setBorrowers(res.data.message);
          // console.log(res.data);
          setisSearchCompeleted(true);
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
        toast.error(err.message);
      });
  };
  // useEffect(() => {
  //   if (query.length === 0) {
  //     axios
  //       .post(url + "/borrower/getall", {
  //         token: token,
  //         email: email,
  //         pageSize: rowNumber,
  //         page: pageCount,
  //       })
  //       .then((res) => {
  //         console.log(res);
  //         if (res.data.logout === true) {
  //           setOpen(false);
  //           setTimeout(() => {
  //             toast.error(res.data.message);
  //             navigate("/");
  //           }, 3000);
  //         }
  //         else if (res.data.auth === false) {
  //           setOpen(false);
  //           // toast.error(res.data.message);
  //         } else {
  //           setOpen(false);
  //           if (res.data.message.length === 0 && pageCount > 1)
  //             return setPageCount((pageCount) => pageCount - 1);
  //           setBorrowers(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         setOpen(false);
  //         // console.log(err);
  //       });
  //   }
  //   if (query && query.length > 0) {
  //     const debounceTimer = setTimeout(() => {
  //       serachDateApi();
  //     }, 500);
  //     return () => {
  //       clearTimeout(debounceTimer);
  //     };
  //   }
  //   // eslint-disable-next-line 
  // }, [query]);
  const handleStatus = (e) => {
    setborrowerStatus(e.target.value);
    setOpen(true);
    axios
      .post(url + "/borrower/completefilter", {
        token: token,
        email: email,
        filter_field: e.target.value,
        pageSize: rowNumber,
        page: pageCount,
      })

      .then((res) => {
        // console.log(res);
        if (!res.data.auth) {
          toast.error(res.data.message);
          setOpen(false);
          return;
        }
        setBorrowers(res.data.message);
        setOpen(false);
      })

      .catch((err) => {
        setOpen(false);
        toast.error(err.message);
      });
  };

  const handleFilter = (filters) => {
    try {
      setFilters(filters);
      setIsFilterApplied(Object.keys(filters).length > 0);

      setOpen(true);
      axios
        .post(url + "/borrower/filterborrower", {
          token: token,
          email: email,
          ...filters,
          pageSize: rowNumber,
          page: pageCount,
        })
        .then((res) => {
          // console.log(res);
          setBorrowers(res.data.message);
          setOpen(false);
          return;
        })
        .catch((err) => {
          setOpen(false);
          toast.error(err.message);
          return;
        });
    } catch (err) {
      console.log(err);
    }

  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
  }
  // eslint-disable-next-line
  const handleChangeBorrowerStatus = (status, uniqueId) => {
    try {
      setOpen(true);
      axios
        .post(url + "/borrower/statuschange", {
          token: token,
          email: email,
          borrower_uniqueno: uniqueId,
          borrowerStatus: status
        })
        .then((res) => {
          console.log(res.data);
          if (!res.data.auth) {
            toast.error(res.data.message);
            setOpen(false);
            return;
          }
          if (res.data.auth) {
            toast.success(res.data.message);
            setOpen(false);
            refresh();;
            return;
          }
        })
        .catch((err) => {
          toast.error(err.message);
          setOpen(false);
        });
    } catch (err) {
      console.log(err);
      return;
    }
  }

  const handleDownloadExcel = async () => {
    setOpen(true);
    try {
      if (!borrowers || borrowers.length === 0) {
        toast.warning("No Borrower Data available to Download.");
        return;
      }

      const formattedData = borrowers.map((borrower) => ({
        "Name": [borrower.borrower_firstname, borrower.borrower_middlename, borrower.borrower_lastname].filter(Boolean).join(" "),
        "Created Date": abc(borrower?.borrower_created_date),
        "Mobile No": borrower?.borrower_mobile,
        "Unique No": borrower?.borrower_uniqueno,
        "Staff Name1": borrower?.borrower_sourcename,
        "Staff ID": borrower?.borrower_sourcecode,
        "Branch Name": borrower?.borrower_branchname,
        "Connector": borrower?.borrower_connector_name?.toUpperCase(),
        "Status": borrower?.borrower_status
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Borrower");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      saveAs(data, `Borrower_Data.xlsx`);
      toast.success("Excel file Downloaded Successfully.");
    } catch (err) {
      console.error("Excel download failed:", err);
      toast.error("Failed to download Excel");
    } finally {
      setOpen(false);
    }
  };

  const findinSearchedList = (id) => {
    if (!id) return false;
    return borrowers.some(val => val.borrower_uniqueno === id.trimStart().trimEnd());
  };
  const refresh = () => {
    setOpen(true);
    axios
      .post(url + "/borrower/getall", {
        token: token,
        email: email,
        pageSize: rowNumber,
        page: pageCount,
      })
      .then((res) => {
        console.log(res);
        if (res.data.logout === true) {
          setOpen(false);
          setTimeout(() => {
            toast.error(res.data.message);
            navigate("/");
          }, 3000);
        }
        else if (res.data.auth === false) {
          setOpen(false);
          // toast.error(res.data.message);
        } else {
          setOpen(false);


          if (res.data.message.length === 0 && pageCount > 1)
            return setPageCount((pageCount) => pageCount - 1);
          setBorrowers(res.data.message);
        }
      })
      .catch((err) => {
        setOpen(false);
        // console.log(err);
      }).finally(() => {
        console.log("refreshing...")
        setOpen(true);
        setRowNumber(10);
        setborrowerStatus(null);
        setQuery("");
        setPageCount(1);
        setSelectedIndex(0);
        setOpen(false);
        toast.success("Borrowers Fetched successfully !");
      })

  }
  useEffect(() => {
    rowRefs.current[selectedIndex]?.focus();
  }, [selectedIndex]);
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setSelectedIndex((prev) => (prev < borrowers.length - 1 ? prev + 1 : prev));
    } else if (e.key === "ArrowUp") {
      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === "Enter") {
      const selectedBorrower = borrowers[selectedIndex];
      if (selectedBorrower?.borrower_uniqueno) {
        window.open(
          `/single/borrower/details/${selectedBorrower?.borrower_uniqueno}`,
          // "_blank",
          "noopener,noreferrer"
        );
        localStorage.setItem(
          "uniqueID",
          selectedBorrower.borrower_uniqueno.trimStart().trimEnd()
        )
      }
    }
  };
  const searchBarKeydown = (e) => {
    if (e.key === "Enter") {
      console.log("isSearchCompeleted=> ", isSearchCompeleted)
      if (!isSearchCompeleted && borrowers?.length > 1 && query?.length > 0) {
        toast.error("Please wait for few seconds we are searching your borrower....")
        return;
      }
      if (!selectedIndex && borrowers.length > 1) {
        toast.error("Please the select the borrower !")
        return;
      }

      if (isSearchCompeleted && borrowers.length > 0 && findinSearchedList(e.target.value)) {
        window.open(
          `/single/borrower/details/${query}`,
          // "_blank",
          "noopener,noreferrer"
        );
        localStorage.setItem(
          "uniqueID",
          query.trimStart().trimEnd()
        )
      }
      else {
        toast.error("Borrower not found !");
      }
    }
    if (e.key === "ArrowDown") {
      rowRefs.current[0].focus();
      setSelectedIndex((prev) => (prev < borrowers.length - 1 ? prev + 1 : prev));
    } else if (e.key === "ArrowUp") {
      rowRefs.current[0].focus();
      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    }
  }

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"ViewBorrower"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container-viewborrower">
            {/* <h2 className="main-heading">
              <AiOutlineTable />
              View Borrowers
            </h2> */}
            <div className="table-borrower-input-fields">
              <div className="table-head-inputs">
                <TextField
                  inputRef={SearchBoxRef}
                  autoComplete="off"
                  placeholder="Borrower Id/ PAN/ Mobile No"
                  name="search-data"
                  id="search-data"
                  value={query}
                  onChange={(e) => {
                    setQuery(e.target.value)
                    setSelectedIndex(0);
                  }}
                  variant="outlined"
                  size="small"
                  onKeyDown={searchBarKeydown}
                />
              </div>
              <button className="digi-kyc" onClick={serachDateApi}>
                Search
              </button>
              <Tooltip title="Filter Borrowers">
                <button style={{ background: "#034ea1", color: "#fff", borderRadius: "3px", cursor: "pointer", }} onClick={handleOpenModal}>
                  {isFilterApplied ? <FilterAltIcon /> : <FilterAltOffIcon />}
                </button>
              </Tooltip>

              <Tooltip title="Download Excel">
                <button className="excel-btn-borrower" onClick={handleDownloadExcel}>
                  <FaFileExcel style={{ color: "green", fontSize: "25px" }} />
                </button>
              </Tooltip>
              <Tooltip title="Refresh">
                <button onClick={refresh}>
                  <RefreshIcon style={{ color: "blue", cursor: 'pointer', fontSize: "25px" }} />
                </button>
              </Tooltip>

              <FilterModal
                open={isModalOpen}
                handleClose={handleCloseModal}
                handleFilter={handleFilter}
                sourceName={sourceName}
                setSourceName={setSourceName}
                branchName={branchName}
                setBranchName={setBranchName}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: 'flex-end',

                  alignItems: 'center',
                  width: "60%",
                }}
              >
                <div style={{ width: '40%' }} >
                  <label style={{ fontWeight: "bold" }}>Status</label>
                  <TextField
                    sx={{ width: '100%' }}
                    className="input-field"
                    select
                    name="created-data"
                    variant="outlined"
                    value={borrowerStatus}
                    size="small"
                    onChange={handleStatus}

                  >
                    <MenuItem value="INCOMPLETE">INCOMPLETE</MenuItem>
                    <MenuItem value="COMPLETE">COMPLETE</MenuItem>
                    <MenuItem value="INCOMPLETE-REJECTED">INCOMPLETE-REJECTED</MenuItem>
                    <MenuItem value="INCOMPLETE-DROPOFF">INCOMPLETE-DROPOFF</MenuItem>
                  </TextField>
                </div>
              </div>

            </div>

            <div
              className="tableField-view-borrower"
              style={{
                borderRadius: "20px",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <TableContainer

                component={Paper}
                sx={{
                  maxHeight: "60vh",
                  minHeight: "60vh",
                  overflowY: 'scroll',
                  borderRadius: "20px",
                  position: 'relative',
                }}
              >
                <Table stickyHeader sx={{
                  tableLayout: "fixed",
                  width: "100%",
                }} className="viewTable-view-borrower">
                  <TableHead>
                    <TableRow >
                      {[
                        "Name",
                        "Created Date",
                        "Mobile No.",
                        "Unique No.",
                        "Staff Name",
                        "Branch Name",
                        "Status",
                        "Action"
                      ].map((head) => {
                        return (<TableCell
                          key={head}
                          align="center"
                          sx={{
                            fontWeight: 600,
                            backgroundColor: "#ced1d8"
                          }}
                        >
                          {head}
                        </TableCell>)
                      })
                      }

                    </TableRow>
                  </TableHead>

                  <TableBody >
                    {borrowers.length > 0 ?
                      borrowers.map((borrower, index) => (
                        <TableRow
                          key={index}
                          // hover
                          selected={index === selectedIndex}
                          tabIndex={0}
                          ref={(el) => (rowRefs.current[index] = el)}
                          onKeyDown={handleKeyDown}
                          sx={{ cursor: "pointer", height: "auto", }}
                          onClick={() => setSelectedIndex(index)} // click to select
                        >

                          <TableCell
                            sx={{
                              wordBreak: "break-word",
                              maxWidth: "150px",
                              whiteSpace: "normal",
                              overflowWrap: "anywhere",
                              width: "12%"
                            }}
                          >
                            {(BorrowerDetailsVisible || visible) ? (
                              <Link
                                to={`/single/borrower/details/${borrower.borrower_uniqueno}`}
                                className="text-blue-600 hover:text-blue-800 hover:underline"
                                onClick={() =>
                                  localStorage.setItem(
                                    "uniqueID",
                                    borrower.borrower_uniqueno
                                  )
                                }
                              >
                                {borrower.borrower_firstname || ""}
                                {borrower.borrower_middlename
                                  ? ` ${borrower.borrower_middlename}`
                                  : ""}
                                {borrower.borrower_lastname
                                  ? ` ${borrower.borrower_lastname}`
                                  : ""}
                              </Link>
                            ) : (
                              <span className="text-gray-900 cursor-default">
                                {borrower.borrower_firstname || ""}
                                {borrower.borrower_middlename
                                  ? ` ${borrower.borrower_middlename}`
                                  : ""}
                                {borrower.borrower_lastname
                                  ? ` ${borrower.borrower_lastname}`
                                  : ""}
                              </span>
                            )}
                          </TableCell>

                          <TableCell>
                            {abc(borrower.borrower_created_date)}
                          </TableCell>

                          <TableCell>{borrower.borrower_mobile}</TableCell>
                          <TableCell>{borrower.borrower_uniqueno}</TableCell>

                          <TableCell>
                            <div className="staff-info">
                              <span className="staff-name">
                                {borrower?.borrower_sourcename}
                              </span>
                              <span className="staff-id">
                                {borrower?.borrower_sourcecode}
                              </span>
                            </div>
                          </TableCell>

                          <TableCell>
                            {borrower?.borrower_branchname}
                          </TableCell>

                          <TableCell>
                            {borrower.borrower_status}
                          </TableCell>

                          <TableCell>
                            {(EditBorrowerVisible || visible) && (
                              <Link to="/borrower/edit" state={borrower}>
                                <button
                                  className="icon-btn"
                                  title="Edit Borrower"
                                >
                                  <BsPencilSquare style={{ fontSize: "20px" }} />
                                </button>
                              </Link>
                            )}
                            {(DeleteBorrowerVisible || visible) && (
                              <button
                                className="icon-btn"
                                title="Delete Borrower"
                              >
                                <ImBin
                                  style={{ color: "#eb1c24", fontSize: "18px" }}
                                  onClick={() =>
                                    handleDeleteBorrower(
                                      borrower.borrower_uniqueno
                                    )
                                  }
                                />
                              </button>
                            )}
                          </TableCell>

                        </TableRow>
                      )) : <TableRow>
                        <TableCell
                          colSpan={8}
                          align="center"
                          sx={{
                            height: 80,
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          No Data Found !
                        </TableCell>
                      </TableRow>}
                  </TableBody>
                </Table>

              </TableContainer>
              <Backdrop
                open={open}
                sx={{
                  height: "100%",
                  position: "absolute",
                  inset: 0,
                  color: "#fff",
                  zIndex: 10,
                  backgroundColor: "rgba(0,0,0,0.4)",
                }}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              {/* Keep Backdrop Outside TableContainer */}

            </div>
            <div className="pagination-div-viewBorrower">
              <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div>
              <div className="pagination-bar">
                <button
                  className="digi-kyc"
                  style={{ marginLeft: "1rem" }}
                  onClick={() => getPageLoad("dec")}
                  disabled={pageCount === 1}
                >
                  Previous
                </button>
              </div>
              <span className="pageCount" style={{ margin: "1rem" }}>
                {pageCount}
              </span>
              <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer closeButton={false} autoClose={2000} />

      </div>
    </>
  );
}